import React from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import PreferencesIcon from '@atlaskit/icon/glyph/preferences';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import ResponsiveButton from '../../common/ui/responsive-button';
import { useSidebarStore } from '../../controllers/sidebar/main.tsx';
import { SidebarStatuses } from '../../controllers/sidebar/types.tsx';
import messages from './messages';

const ConfigurationButton = () => {
	const { formatMessage } = useIntl();
	const [sidebarState, sidebarActions] = useSidebarStore();
	const onOpen = sidebarActions.showConfiguration;
	const onClose = sidebarActions.close;
	const isOpen = sidebarState.status === SidebarStatuses.SHOWING_CONFIGURATION;
	const tooltipContent = formatMessage(messages.tooltip);

	return (
		<Tooltip position="bottom" content={tooltipContent}>
			<ResponsiveButton
				testId="software-deployments.ui.configuration-button.configure-view-button"
				onClick={(event, analyticsEvent: UIAnalyticsEvent) => {
					if (isOpen) {
						onClose();
						return;
					}
					fireUIAnalytics(analyticsEvent, 'configureDeployments');
					onOpen();
				}}
				icon={<PreferencesIcon label={formatMessage(messages.buttonIconLabel)} />}
				isSelected={isOpen}
				text={formatMessage(messages.configuration)}
			/>
		</Tooltip>
	);
};

export default ConfigurationButton;
